// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_e27_ring/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_e27_ring: ModuleSchema = {
  "id": "core_e27_ring",
  "uniqueId": "B3D_E27RG",
  "createdAt": "2026-10-02T05:59:37.258Z",
  "updatedAt": "2026-10-28T14:58:31.527Z",
  "label": "E27 Ring",
  "description": "core_e27_ring parametric 3D model",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_E27"
  ],
  "sliders": [
    {
      "key": "collarThreadDia",
      "label": "Internal Thread Diameter (M60=60mm)",
      "min": 50,
      "max": 70,
      "step": 1,
      "default": 60,
      "unit": "mm"
    },
    {
      "key": "collarOuterDia",
      "label": "Outer Grip Diameter (Ø)",
      "min": 60,
      "max": 85,
      "step": 1,
      "default": 70,
      "unit": "mm"
    },
    {
      "key": "collarHeight",
      "label": "Ring Height",
      "min": 6,
      "max": 18,
      "step": 0.5,
      "default": 10,
      "unit": "mm"
    },
    {
      "key": "collarPitch",
      "label": "Thread Pitch",
      "min": 2,
      "max": 4,
      "step": 0.5,
      "default": 3,
      "unit": "mm"
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "e27_collar_ring",
      "label": "E27 Collar Ring",
      "default": "#f59e0b",
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [
    {
      "id": "e27_ring_obj",
      "label": "E27 Collar Ring",
      "name": "E27 Collar Ring",
      "color": "#f59e0b",
      "assembled_z_offset": 0,
      "exploded_z_offset": 25,
      "parts": [
        {
          "id": "e27_collar_ring",
          "label": "E27 Collar Ring",
          "name": "E27 Collar Ring",
          "groupId": 0,
          "colorKey": "e27_collar_ring",
          "defaultColor": "#f59e0b",
          "assembled_z_offset": 0,
          "exploded_z_offset": 25,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": []
};
